import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import RouteName from "./../../routes/Route.name";
import {
  actionFetchPrograms,
  actionSetPageProgramsRequests,
} from "./../../actions/Program.action";
import {
  serviceProgramExport
} from "./../../services/Program.service";
import history from "./../../libs/history.utils";

const useProgramListHook = ({}) => {
  const [editData, setEditData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const isMountRef = useRef(false);
  const {
    sorting_data: sortingData,
    is_fetching: isFetching,
    query,
    query_data: queryData,
    all,
  } = useSelector((state) => state?.program);

  useEffect(() => {
    dispatch(
      actionFetchPrograms(
        1,
        {},
        {
          query: isMountRef.current ? query : null,
          query_data: isMountRef.current ? queryData : null,
          
        }
      )
    );
    isMountRef.current = true;
  }, []);

  const handlePageChange = useCallback((type) => {
    dispatch(actionSetPageProgramsRequests(type));
  }, []);

  const queryFilter = useCallback(
    (key, value) => {
      dispatch(
        actionFetchPrograms(1, sortingData, {
          query: key == "SEARCH_TEXT" ? value : query,
          query_data: key == "FILTER_DATA" ? value : queryData,
        })
      );
    },
    [sortingData, query, queryData]
  );

  const handleFilterDataChange = useCallback(
    (value) => {
      queryFilter("FILTER_DATA", value);
    },
    [queryFilter]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      queryFilter("SEARCH_TEXT", value);
    },
    [queryFilter]
  );

  const handleSortOrderChange = useCallback(
    (row, order) => {
      // dispatch(actionSetPageProgramsRequests(1));
      dispatch(
        actionFetchPrograms(
          1,
          { row, order },
          {
            query: query,
            query_data: queryData,
            
          }
        )
      );
    },
    [query, queryData]
  );

  const handleDetail = useCallback((type) => {
    history.push(`${RouteName.PROGRAM_DETAIL}${type?.id}`);
  }, []);

  const handleCreate = useCallback(() => {
    history.push(RouteName.PROGRAM_CREATE);
  }, []);

  const handleEdit = useCallback((type) => {
    history.push(`${RouteName.PROGRAM_UPDATE}${type?.id}`);
  }, []);

  const handleExport = useCallback(()=> {
    setIsSubmitting(true);
    serviceProgramExport({
      index: 1,
      row: sortingData?.row,
      order: sortingData?.order,
      query: query,
      query_data: queryData,
    }).then((res) => {
      if (!res.error) {
        const data = res.data;
        window.open(data, "_blank");
      }
      setIsSubmitting(false);
    });
  }, [sortingData, query, queryData]);

  const configFilter = useMemo(() => {
    return [
    
      {
        label: "Status",
        name: "status",
        type: "select",
        fields: ["ACTIVE", "INACTIVE"],
      },
    ];
  }, []);

  return {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleSortOrderChange,
    handleDetail,
    editData,
    configFilter,
    handleCreate,
    handleEdit,
    handleExport,
    isSubmitting
  };
};

export default useProgramListHook;
